import useFetchChartData from '@hooks/useFetchChartData'
import {
  AnalyticsGraphDataBase,
  FetchUserAnalyticsGraphParams,
} from '@models/user/UserAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { FC } from 'react'
import { Legend, Pie, PieChart, Tooltip } from 'recharts'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'

const AverageSessionDuration: FC = () => {
  const { data, isLoading, error } = useFetchChartData<
    FetchUserAnalyticsGraphParams,
    AnalyticsGraphDataBase
  >({
    entity: 'user',
    kind: 'app-average-session-duration',
    fetchFunction: fetchAnalyticsGraph,
  })

  return (
    <BaseChart
      title="Average session duration"
      help="Average duration of user sessions in the app over the selected time range."
      data={data}
      isLoading={isLoading}
      error={error}
      height={350}
    >
      <PieChart data={data}>
        <Pie
          cornerRadius={9}
          data={data}
          nameKey={'label'}
          dataKey={'count'}
          fill="#8884d8"
        >
          <Tooltip
            content={(props) => (
              <CustomTooltip
                type="bar"
                {...props}
                customLabelFormatter={(payload) => {
                  return payload.label
                }}
              />
            )}
          />
          <Legend align="right" layout="vertical" verticalAlign="middle" />
        </Pie>
      </PieChart>
    </BaseChart>
  )
}

export default AverageSessionDuration
